import { Grid, Typography } from "@mui/material";
import React from "react";
 

const LayoutBanner = ({title,body,image}) => {
  return (
    <Grid
      container
      sx={{ background: "#EFF9FF", borderRadius: "24px", padding: "2%" }}
      marginTop={2}
      justifyContent={"space-between"}
    >
      <Grid item sm={12} md={8} my={"auto"}>
        <Typography
          variant="h5"
          fontSize={"20px"}
          fontWeight={500}
          marginBottom={"15px"}
        >
          {title}
        </Typography>
        <Typography variant="body1" textAlign={"justify"} color={"#000000B2"}>
          {body}
        </Typography>
      </Grid>
      <Grid item sm={12} md={4}>
        <img src={image} className="img-fluid center" alt="etl" />
      </Grid>
    </Grid>
  );
};

export default LayoutBanner;
